const badgesCollection = [
    {
        badge_id: null,
        img_name_blank: "Pelican-no-badge.png",
        img_name: "Pelican-no-badge.png",
        name: "NO badge",
        points: 0
    },
    {
        badge_id: 0,
        img_name_blank: "Pelican-no-badge.png",
        img_name: "Pelican-no-badge.png",
        name: "NO badge",
        points: 0
    },
    {
        badge_id: 1,
        img_name_blank: "Pelican-1-points.png",
        img_name: "Pelican-1.png",
        name: "Pelican 1",
        points: 2
    },
    {
        badge_id: 2,
        img_name_blank: "Pelican-2-points.png",
        img_name: "Pelican-2.png",
        name: "Pelican 2",
        points: 5
    },
    {
        badge_id: 3,
        img_name_blank: "Pelican-3-points.png",
        img_name: "Pelican-3.png",
        name: "Pelican 3",
        points: 10
    },
    {
        badge_id: 4,
        img_name_blank: "Pelican-4-points.png",
        img_name: "Pelican-4.png",
        name: "Pelican 4",
        points: 20
    },
    {
        badge_id: 5,
        img_name_blank: "Pelican-5-points.png",
        img_name: "Pelican-5.png",
        name: "Pelican 5",
        points: 40
    },
    {
        badge_id: 6,
        img_name_blank: "Pelican-6-points.png",
        img_name: "Pelican-6.png",
        name: "Pelican 6",
        points: 80
    },
    {
        badge_id: 7,
        img_name_blank: "Pelican-pro-points.png",
        img_name: "Pelican-pro.png",
        name: "Pelican Pro",
        points: 160
    },
    {
        badge_id: 8,
        img_name_blank: "Pelican-star-points.png",
        img_name: "Pelican-star.png",
        name: "Pelican Star",
        points: 320
    },
    {
        badge_id: 9,
        img_name_blank: "Pelican-ufo-points.png",
        img_name: "Pelican-ufo.png",
        name: "Pelican Ufo",
        points: 640
    },
];

export default badgesCollection;

